module.exports = __webpack_public_path__ + "img/nitick.5014a086.svg";